<template functional>
	<div
		v-html="$options.methods.buildHTMLMixin(props)"
		style="margin: 0; padding: 0; height: 100%;"
		@mouseenter="$options.methods.showTooltip($options, props, listeners, true)"
		@mouseleave="$options.methods.showTooltip($options, props, listeners, false)"
		@click="$options.methods.onDaySelected(props, listeners)">
	</div>
</template>

<script>
import { Constants } from '../Constants.js';
import CalendarDayFactory from './CalendarDayFactory.js';

export default {
	name: 'CalendarDay',
	mixins: [CalendarDayFactory],
	props: {
		index: Number,
		type: Number,
		data: Object, 
		employee: Object,
		vacation: Array,
		onlyVacationData: Boolean,
		calendars: Array,
		projects: Array,
		isDisabled: Boolean,
		isCheckinDisabled: Boolean,
		isCalendarVisible: Boolean,
		isVacation: Boolean,
		vac: Object,
		colors: Array,
		tips: Array,
		tooltip: Object,
		hasTooltip: Boolean,
		projectsTextAndColor: Array,
		showTooltipTimeoutId: Number,
	},
	methods: {
		showTooltip($options, props, listeners, show) {		
			if (!props.hasTooltip) {
				return;
			}

			if (show) {
				props.showTooltipTimeoutId = setTimeout(function() {
					listeners['show-tooltip']({ index: props.index, text: $options.methods.getTooltipText(props) });
				}, 200);
				return;
			}

			clearTimeout(props.showTooltipTimeoutId);
			listeners['hide-tooltip']();
		},
		onDaySelected(props, listeners) {
			if (props.isDisabled) {
				return;
			}
			
			if ((props.type === Constants.MONTHLYDAY_TYPE || props.type === Constants.WEEKLYDAY_TYPE) && props.isVacation) {
				listeners['show-menu']({ index: props.index, day: { employee: props.employee, calendar: props.data, vacation: props.vac } });
				return;
			}

			if (props.type === Constants.MONTHLYDAY_TYPE) {
				listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: null });
			} else if (props.type === Constants.WEEKLYDAY_TYPE) {
				listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: props.vac });
			} else if (props.type === Constants.HOLLYDAY_TYPE) {
				listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: props.vac });
			}
		},
		getTooltipText(props) {
			if (props.tooltip) {
				return props.tooltip;
			}

			let text = '';

			for (let i = 0; i < props.tips.length; i++) {
				const tip = props.tips[i];
				if (text && text.length > 0) {
					text +=  '  |  ';
				}	
				text += tip;
			}

			return text;
		},
		buildHTMLMixin(props) {
			return this.buildHTML(props);
		},
	}
}
</script>